<template>
  <div class="view pa24">
    <el-form :model="serchParams" class="demo-form-inline" :inline="true">
      <el-row style="padding-top: 20px;">
        <el-form-item label="批次号" label-width="70px" label-position="left" class="fromItem" prop="lotNumber">
          <el-input v-model="serchParams.lotNumber" placeholder="请输入批次号" clearable></el-input>
        </el-form-item>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-row>
    </el-form>
    <div class="d-flex">
      <el-button class="ma" type="primary" @click="handleAddOrder('add')">+创建空白码</el-button>
    </div>
    <commonTable
        :tableData="tableData"
        :total="total"
        :currentPage="pageNum"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:table>
        <el-table-column
            prop="className"
            align="center"
            label="关联产品"
        >
        </el-table-column>
        <el-table-column align="center"
                         label="类型">
          <template slot-scope="scope">
            {{formatType(scope.row.type)}}
          </template>
        </el-table-column>
        <el-table-column
            prop="lotNumber"
            align="center"
            label="批次号"
        >
          <template slot-scope="scope">
            <span @click="goHandlePageList(scope.row)" class="losSpanLeft">
                  {{ scope.row.lotNumber }}
                </span>
          </template>
        </el-table-column>

        <el-table-column
            prop="num"
            align="center"
            label="数量"
        >
          <template slot-scope="scope">
          <span>
            {{ scope.row.num }}
          </span>
            <span v-if="scope.row.num && scope.row.num!==scope.row.regNum" style="position:relative; top:10px;">
            <el-progress :width="40" :height="40" type="circle"
                         :percentage="getPercentage(scope.row)"></el-progress>
          </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="remark"
            align="center"
            label="备注"
        >
        </el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="创建时间"
        />
        <el-table-column align="center" width="200" label="操作">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.bindStatus == 0 &&scope.row.num==scope.row.regNum" @click="toSetPage( scope.row)">
              配置页面
            </el-button>
            <span v-if="scope.row.bindStatus == 2" class="configuring-text">页面配置中，请等待...</span>
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <bind-page-dialog ref="bindPageDialog" @success="getList"></bind-page-dialog>

    <add-handle ref="addHandleDialog" @refreshList="getList"></add-handle>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import addHandle from "./addHandle.vue";
import bindPageDialog from "./bindPageDialog.vue";
import {
  selectBatchList
} from '@/api/customPageBatch.js'
import {checkPermission} from "@/directives/permission";

export default {
  name: "dealerList",
  components: {
    commonTable,
    addHandle,
    bindPageDialog,
  },
  data() {
    return {
      changeDealerList: [],
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      wareStatus: 2,
      serchParams: {
        classId: '',
        dealerId: '',
        timeRange: [],
        lotNumber: '',
        status: '',
      },
      classOptions: [],
      dealerOptions: [],
      storeOptions: [],
      labelName: '',
      pollTimer: null,
      pollInterval: 3000,
      fetchVersion: 0,
      typeOptions:[
        {
          value: 1,
          label: '宣传物料（海报、彩页、手册、手提袋、纸巾包、钥匙扣等）'
        },
        {
          value: 2,
          label: '产品'
        },
        {
          value: 3,
          label: '箱标'
        },
        {
          value: 4,
          label: '证书'
        },
        {
          value: 5,
          label: '盒标'
        },
        {
          value: 6,
          label: '套标'
        },
      ],
    };
  },
  created() {
    this.getList()
  },
  beforeDestroy() {
    this.stopPoll()
  },
  methods: {
    checkPermission,
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    handleAddOrder(type, data) {
      this.$refs.addHandleDialog.createHandle(data)
    },
    formatType(type){
      return this.typeOptions.filter(item=>item.value==type)[0].label
    },
    // 过滤掉空的children
    formatData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children == null || data[i].children.length == 0) {
          data[i].children = undefined;
        } else if (data[i].children.length > 1) {
          this.formatData(data[i].children);
        }
      }
      return data;
    },
    search() {
      this.pageNum = 1
      this.getList()
    },
    resetSearch() {
      this.serchParams.lotNumber = ''
      this.pageNum = 1
      this.getList()
    },
    getList() {
      this.stopPoll()
      const version = ++this.fetchVersion
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        lotNumber: this.serchParams.lotNumber,
      }
      selectBatchList(params).then(res => {
        if (version !== this.fetchVersion) return
        this.tableData = res.data.list
        this.total = res.data.total
        this.correctPageNum()
        this.checkPoll()
      })
    },
    getPercentage(row) {
      if (!row.num) return 0
      return Math.round(row.regNum / row.num * 10000) / 100
    },
    hasIncompleteRows() {
      return this.tableData.some(row => row.num && row.num !== row.regNum)
    },
    checkPoll() {
      if (this.hasIncompleteRows() || this.hasBindConfiguringRows()) {
        this.startPoll()
      } else {
        this.stopPoll()
      }
    },
    startPoll() {
      if (this.pollTimer) return
      this.pollTimer = setInterval(() => {
        this.pollProgress()
      }, this.pollInterval)
    },
    stopPoll() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    hasBindConfiguringRows() {
      return this.tableData.some(row => row.bindStatus == 2)
    },
    correctPageNum() {
      const maxPage = Math.max(1, Math.ceil(this.total / this.pageSize))
      if (this.pageNum > maxPage) {
        this.pageNum = maxPage
      }
    },
    pollProgress() {
      const version = ++this.fetchVersion
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        lotNumber: this.serchParams.lotNumber,
      }
      selectBatchList(params).then(res => {
        if (version !== this.fetchVersion) return
        this.tableData = res.data.list
        this.total = res.data.total
        this.correctPageNum()
        this.checkPoll()
      })
    },
    goHandlePageList(row) {
      if (row.num != row.regNum){
        this.$message({
          message: '请等待生码完成',
          type: 'warning'
        })
        return
      }
      let {lotNumber, customPageId, isRead, isBind, type, hasInCode, hzpFlag, goodCode, encodingType} = row
      if (encodingType && (encodingType == 1 || encodingType == 2)) {
        getEncoding({pageId: customPageId})
            .then(res => {
              if (res.code == 200) {
                let {gsCode, idenCode, verificationCode} = res.data
                this.$router.push({
                  path: '/mkc/handlePageList',
                  query: {
                    lotNumber: lotNumber,
                    customPageId: customPageId,
                    isRead: isRead,
                    isBind: isBind,
                    type: type,
                    hasInCode: hasInCode,
                    isHzp: hzpFlag,
                    goodsCode: goodCode,
                    gsCode: gsCode,
                    idenCode: idenCode,
                    verificationCode: verificationCode
                  }
                })
              }
            })
      } else {
        this.$router.push({
          path: '/mkc/handlePageList',
          query: {
            lotNumber: lotNumber,
            customPageId: customPageId,
            isRead: isRead,
            isBind: isBind,
            type: type,
            hasInCode: hasInCode,
            isHzp: hzpFlag,
            goodsCode: goodCode,
            bindStatus:0
          }
        })
      }
    },
    toSetPage(row) {
      this.$refs.bindPageDialog.open(row.batchId,row.classId,row.type==3?true:false)
    }
  }
}
</script>

<style lang="scss" scoped>
.losSpanLeft {
  text-decoration: underline;
  color: #51CBCD;
  cursor: pointer;
}

.configuring-text {
  color: #E6A23C;
  font-size: 13px;
}

.name_status {
  display: inline-block;
  width: 26px;
  height: 17px;
  line-height: 15px;
  background: rgba(63, 114, 246, 0.11);
  border: 1px solid #3F72F6;
  border-radius: 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3F72F6;
  text-align: center;
}

.name_status1 {
  display: inline-block;
  width: 26px;
  height: 17px;
  line-height: 15px;
  background: rgba(243, 136, 46, 0.11);
  border: 1px solid #F3882E;
  border-radius: 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #F3882E;
  text-align: center;
}

.copyTxt {
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
  color: #3F72F6;
}

.greenTag {
  color: #fff;
  background: #08A89B;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;

}

.greyTag {
  background: #e5e5e5;
  color: #333;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;

}

.redTag {
  background: #e5e5e5;
  color: #f00;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;
}

.redBtn, .redColor {
  color: #f00;
}
</style>
